import { COMPANY_FILTER_CHANGE } from '../../PartnerOptions/constants'
import { CHANGE_INCIDENT_STATE_REQUEST_ASYNC } from '../AtoIncident/Header/constants'
import { REGULAR_FILTERS_SUBMIT } from '../IncidentFilters/constants'
import { QUICK_FILTERS_CHANGE } from '../QuickFilters/constants'
import { REPORT_STATE_CHANGE_ASYNC } from '../Report/constants'
import {
  CHALLENGED_TYPE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  SEARCH_CHANGE,
  SORTING_FILTER_CHANGE,
} from '../TopBar/constants'

import { LIST_REQUEST_ASYNC, PAGINATE_CHANGE, REPORT_SELECT, URL_STATE_CHANGE } from './constants'

export default function () {
  const initialState = {
    data: {
      reports: {
        results: [],
      },
    },
    loader: false,
    selectedReportId: null,
    selectedReportType: null,
    urlState: null,
    error: null,
    page: 1,
    firstPageLoadDate: '',
    lastRowDate: '',
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_CHANGE:
      case SORTING_FILTER_CHANGE:
      case GENERAL_FILTER_CHANGE:
      case QUICK_FILTERS_CHANGE:
      case REGULAR_FILTERS_SUBMIT:
      case COMPANY_FILTER_CHANGE:
      case CHALLENGED_TYPE_FILTER_CHANGE:
      case REPORT_STATE_CHANGE_ASYNC.SUCCESS:
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          loader: true,
          selectedReportId: null,
          selectedReportType: null,
          page: 1,
          firstPageLoadDate: '',
          lastRowDate: '',
        }
      case PAGINATE_CHANGE: {
        const isFirstPage = action.payload.page === 1
        return {
          ...state,
          page: action.payload.page || state.page + 1,
          loader: isFirstPage ? true : state.loader,
          selectedReportId: isFirstPage ? null : state.selectedReportId,
          selectedReportType: isFirstPage ? null : state.selectedReportType,
          firstPageLoadDate: isFirstPage ? '' : state.firstPageLoadDate,
          lastRowDate: isFirstPage ? '' : state.lastRowDate,
        }
      }

      case URL_STATE_CHANGE:
        return {
          ...state,
          loader: true,
          urlState: action.payload.urlState,
          selectedReportId: null,
          selectedReportType: null,
          page: 1,
          firstPageLoadDate: '',
          lastRowDate: '',
        }
      case REPORT_SELECT:
        return {
          ...state,
          selectedReportId: action.payload.id,
          selectedReportType: action.payload.type,
        }
      case LIST_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          loader: !action.payload.isPolling,
        }
      case LIST_REQUEST_ASYNC.SUCCESS: {
        const items = action.payload.data.reports.results
        const isSelectedItemInsideList =
          state.selectedReportId && items.some((item) => item.id === state.selectedReportId)

        return {
          ...state,
          error: null,
          loader: false,
          data:
            state.page <= 1
              ? action.payload.data
              : {
                  ...action.payload.data,
                  reports: {
                    results: [...state.data.reports.results, ...items],
                  },
                },
          selectedReportId:
            isSelectedItemInsideList || state.page > 1
              ? state.selectedReportId
              : items[0]?.id || null,
          selectedReportType:
            isSelectedItemInsideList || state.page > 1
              ? state.selectedReportType
              : items[0]?.reportType || null,
          firstPageLoadDate: action.payload.data.firstPageLoadDate,
          lastRowDate: action.payload.data.lastRowDate,
        }
      }
      case LIST_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
        }
      case LIST_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
        }
      default:
        return state
    }
  }
}
